import { modalReturnCheckAlertStore } from '@/store'
import { modalAlertParameterInterface } from '@/store/ModalAlertStore'

export class ModalReturnCheckAlertService {
  public open(params?: modalAlertParameterInterface) {
    modalReturnCheckAlertStore.open(params)
  }

  public close() {
    modalReturnCheckAlertStore.close()
  }
}
